import React from 'react';
import styled from 'react-emotion';
import List from '../../Symbols/List';
import Title from '../../Symbols/Title';
import labels from '../../Labels';

const PromoList = styled(List)`
	a,
	button {
		display: block;
		color: #fff;
		background: #1B69BF;
		font-family: 'Barlow', sans-serif;
		font-size: 0.79rem;
		font-weight: 700;
		text-decoration: none;
		line-height: 45px;
		padding: 0 2rem 0 1rem;
		margin-left: 5px;
		margin-right: 5px;
		margin-bottom: 24px;
		border-radius: 2px;
		border: 1px solid #d2d9dd;
		text-transform: uppercase;

		&:hover {
			background: #1B69BF;
			text-decoration: none;
			cursor: pointer;
		}
		
		&:focus {
			outline-color: #1B69BF;
		}
		
		@media (max-width: 410px) {
			text-align: center;
			line-height: unset;
			min-height: 52px;
			display: flex;
			align-items: center;
		}
	}
`

const PromoListWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	flex-wrap: wrap;
`

export default (props) => {
	if (!props.links.length && props.roundIndex === undefined) {
		return null;
	}

	return <PromoList>
		<Title>Související</Title>
		<PromoListWrapper>
			{props.links.map(link => (
				<li key={link.url}>
					<a href={link.url}>{link.text}</a>
				</li>
			))}
			{props.roundIndex !== undefined && <li>
				<button onClick={props.toggleRound}>
					Senátní volby - {labels.otherRound[props.roundIndex]}. kolo -
					{props.isDetail ? ' přehled za obvod' : ' celkový přehled'}
				</button>
			</li>}
		</PromoListWrapper>
	</PromoList>;
}
